/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import queryString from 'query-string';
import DokanItemsFilterbyStatus from '../../components/filter/DokanItemsFilterbyStatus';
import DokanItemDateFilter from '../../components/filter/DokanItemDateFilter';
import { fetchOrdersSummary } from '../../redux/orders/ordersActions';

function OrderFilterByStatus() {
    const ordersSummary = useSelector((state) => state.orders.ordersSummary);
    const dispatch = useDispatch();
    const ordersStatus = useMemo(() => {
        const availableStatus = [];
        if (Object.keys(ordersSummary)) {
            // eslint-disable-next-line array-callback-return
            Object.keys(ordersSummary).map((status) => {
                const currentStatusValue = ordersSummary[status];
                const splitStatus = status.split('-');
                const singleStatus = {};
                if (splitStatus.length && splitStatus.length === 2) {
                    singleStatus.name = splitStatus[1].toUpperCase();
                    singleStatus.status = status;
                    singleStatus.value = currentStatusValue;
                    availableStatus.push(singleStatus);
                } else if (splitStatus.length && splitStatus.length === 3) {
                    const first = splitStatus[0];
                    const restofstring = status.replace(`${first}-`, '');
                    singleStatus.name = restofstring.toUpperCase();
                    singleStatus.status = status;
                    singleStatus.value = currentStatusValue;
                    availableStatus.push(singleStatus);
                } else {
                    singleStatus.name = status === 'total' ? 'All' : status.toUpperCase();
                    singleStatus.status = status === 'total' ? '' : status.toUpperCase();
                    singleStatus.value = currentStatusValue;
                    availableStatus.push(singleStatus);
                }
            });
        }
        availableStatus.sort((a, b) => (a.name > b.name ? 1 : -1));
        return availableStatus.sort();
    }, [ordersSummary]);
    useEffect(() => {
        dispatch(fetchOrdersSummary());
    }, [dispatch]);

    const { pathname, search } = useLocation();
    const history = useHistory();

    // prepare query-string parameter
    const prepareQueryString = (qParamObj) => new URLSearchParams(qParamObj);
    // const queryParameter1 = prepareQueryString();
    // console.log(queryParameter1.get('status'));
    // eslint-disable-next-line prefer-const
    let isActive = '';

    const handleSearchByStatus = (qParam) => {
        if (qParam.status) {
            const queryParameter = prepareQueryString(qParam);
            console.log(queryParameter.get('status'));

            // const prepareNewUrl = `${pathname}?${queryParameter}`;
            const newURL = queryString.stringifyUrl({
                url: pathname + search,
                query: qParam,
            });
            history.replace(newURL);
        } else history.replace(pathname);
    };

    return (
        <>
            <div className="flex justify-between items-center">
                <div className="flex">
                    {ordersStatus.map((label, index) => (
                        <DokanItemsFilterbyStatus
                            label={`${label.name} (${label.value})`}
                            key={index}
                            queryParameterKey="status"
                            queryParameterValue={label.status}
                            defaultActiveLabel=""
                        />
                    ))}
                </div>
                <div>
                    <DokanItemDateFilter />
                </div>
            </div>
        </>
    );
}

export default OrderFilterByStatus;
